import { render, staticRenderFns } from "./SalesLayout.vue?vue&type=template&id=5920c355&"
import script from "./SalesLayout.vue?vue&type=script&lang=js&"
export * from "./SalesLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports